import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { postDriver } from "../actions/driverAction";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Navbar from "react-bootstrap/Navbar";

class CreateDriverProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      icloud_email: "",
      mobile_contact_number: "",
      iPhone: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props;
  }
  handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData();
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    formData.append("driver[first_name]", this.state.first_name);
    formData.append("driver[last_name]", this.state.last_name);
    formData.append("driver[icloud_email]", this.state.icloud_email);
    formData.append(
      "driver[mobile_contact_number]",
      this.state.mobile_contact_number
    );
    formData.append("driver[iPhone]", this.state.mobile_phone_type);
    this.props.postDriver(formData, config);
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  render() {
    return (
      <div className="container-fluid">
        <Form onSubmit={this.handleSubmit}>
          <h3 className="text-center">Create new Mile1 driver</h3>
          <br></br>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                name="first_name"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                name="last_name"
                onChange={this.handleInputChange}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridMobile">
              <Form.Label>Mobile Phone</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                name="mobile_contact_number"
              />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>Apple iPhone?</Form.Label>
              <Form.Check name="iPhone" onChange={this.handleInputChange} />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>iCloud Email</Form.Label>
              <Form.Control
                name="icloud_email"
                onChange={this.handleInputChange}
              />
            </Form.Group>
          </Form.Row>
          <Button type="submit" variant="info">
            Create Driver
          </Button>
        </Form>
        <Link to="/stats">
          <Button variant="link">Back to Stakeholders</Button>
        </Link>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  postDriver: (driver) => dispatch(postDriver(driver)),
});
export default withRouter(
  connect(null, mapDispatchToProps)(CreateDriverProfile)
);
